<!-- <script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },

    command: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      selectedIndex: 0,
    }
  },

  watch: {
    items() {
      this.selectedIndex = 0
    },
  },

  methods: {
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler()
        return true
      }

      if (event.key === 'ArrowDown') {
        this.downHandler()
        return true
      }

      if (event.key === 'Enter') {
        this.enterHandler()
        return true
      }

      return false
    },

    upHandler() {
      this.selectedIndex = ((this.selectedIndex + this.items.length) - 1) % this.items.length
    },

    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length
    },

    enterHandler() {
      this.selectItem(this.selectedIndex)
    },

    selectItem(index) {
      const item = this.items[index]

      if (item)
        this.command({ id: item })
    },
  },
}
</script> -->

<script setup lang="ts">
import { ref, watch } from 'vue'
import ResourceImage from '@/components/resource/resourceImage.vue'

const props = defineProps<{
  items: Array<{
    _id: string
    display: string
  }>
  command: (item: { id: string; firstname: string; lastname: string; picture: string; label: string }) => void
  // label: string
  // placeholder: string
  // disableLabelSingleSelection?: boolean
  // asyncSearch?: boolean
}>()

const selectedIndex = ref(0)

watch(() => props.items, () => {
  selectedIndex.value = 0
}, { deep: true })

const selectItem = (index) => {
  const item = props.items[index] as {
    _id: string
    firstname?: string
    lastname?: string
    picture?: string | null
  }
  if (!item?._id)
    return

  props.command({
    id: String(item._id),
    firstname: item.firstname || '',
    lastname: item.lastname || '',
    picture: item.picture || '',
    label: `${item.firstname || ''} ${item.lastname || ''}`.trim(),
  })
}

const onKeyDown = ({ event }) => {
  if (event.key === 'ArrowUp') {
    upHandler()
    return true
  }
  else if (event.key === 'ArrowDown') {
    downHandler()
    return true
  }
  else if (event.key === 'Enter' && props.items[selectedIndex.value]) {
    selectItem(selectedIndex.value)
    return true
  }

  return false
}

const upHandler = () => {
  selectedIndex.value = (((selectedIndex.value + props.items.length) - 1) % props.items.length)
  console.log('selectedIndex.value', selectedIndex.value)
}

const downHandler = () => {
  selectedIndex.value = (selectedIndex.value + 1) % props.items.length
}

const enterHandler = () => {
  selectItem(selectedIndex.value)
}

defineExpose({
  onKeyDown,
  upHandler,
  downHandler,
  enterHandler,
})
</script>

<template>
  <div
    class="dropdown-menu card-base flex flex-col"
    data-cy="mention-suggestion-list"
  >
    <template v-if="items.length">
      <button
        v-for="(item, index) in items"
        :key="index" class="hover:bg-primary-500 hover:text-white w-full px-2 py-1 flex gap-2 rounded-sm"
        :class="{ 'bg-primary-400 text-white': index === selectedIndex }"
        :data-cy="`mention-suggestion-${item.display || item._id || index}`"
        @click="selectItem(index)"
      >
        <ResourceImage :resource="item" /> {{ item.firstname }} {{ item.lastname }}
      </button>
    </template>
    <div v-else class="item">
      No result
    </div>
  </div>
</template>

<style>
/* Dropdown menu */
.dropdown-menu {

}
</style>
